//
//
//
//
//
//
//
//
//
//

export default {
    name: "VideoLibraryResultsItemDialog",
    props: ["result"],
    computed: {
        videoCode() {
            return this.result.meta.videoembedcode;
        }
    },
    data () {
        return {
            open: false
        }
    },
    methods: {
        closeModal() {
            
            this.$el.classList.remove('is-active')
            setTimeout(() => {
                // probably unnecessary with the $emit
                this.$el.close()
                this.$emit('close')
            }, 350)
            
        }
    },
    mounted() { 
        const root = this;
        root.$el.showModal();

        setTimeout(() => {
            root.$el.classList.add('is-active');

            //Fire tracking event
            if (root.$root.options.activityEndpoint && root.result.nodeId) {
                fetch(root.$root.options.activityEndpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        "NodeId": root.result.nodeId,
                        "Title": root.result.title,
                        "ContactGuid": getCookie('CurrentContact'),
                        "Url": root.result.url,
                        "EmbedCode": root.embedCode
                    })
                })
            }
        }, 350)
        // this.showModal()
    }
};      

function getCookie(name) {
  return document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=")[1];
}
